<template>
    <div>
        <a-input size="small" :style="option.showDirect ? 'width:60%' : 'width:100%'" v-model="systemName" :id="option.id ? option.id : 'orgInput2'" :placeholder="$t('home.pleaseSelectAScene')" readonly></a-input>
        <a-checkbox v-if="option.showDirect" v-model="option.directFlag" style="padding-left:5px" @change="directChange">{{$t('global.currentOrg')}}</a-checkbox>
        <ul id="treeDiv" class="ztree" style="min-width:200px;background-color: #f9f9f9;border: 1px solid #ccc;margin-top:5px" v-show="isSelectOrg" v-bind:class="{absoluteTree: !option.isRelative }">
            <a-input v-if="orgData.length" ref="searchInput" autofocus :placeholder="$t('global.inputFliterTip')" v-model="searchInput" style="margin-bottom:8px"></a-input>
            <z-scene-chooser-item :treeData="orgData"  @selectNode="onSelectNode"></z-scene-chooser-item>
        </ul>
    </div>
</template>

<script>
    // import ZOrgChooserItem from './OrgChooserItem.vue'
    import ZSceneChooserItem from './SceneChooserItem.vue'
    import config from '@/config'
    import lodash from 'lodash'

    export default {
        name: "ZOrgChooser",
        props: ["option", "orgId"],
        components: {
            // ZOrgChooserItem,
            ZSceneChooserItem,
        },
        data: function () {
            return {
                systemName: '',
                orgData:'',
                isSelectOrg: false,
                searchInput: '',
                tempObj: null,
                selectedId: null,
                orgLink: null
            }
        },
        watch: {
            searchInput: function () {
                this.filterOrg()
            },
            orgId(val) {
                console.log(val)
              this.orgLink = val
              this.initOrgTree()
            }
        },
        created() {
            // this.initOrgTree()
           
        },
        methods: {
            getFilterOrg() {
                if (this.searchInput.length > 0){
                    this.orgData = JSON.parse(this.tempObj)
                    this.filterNode(this.orgData)
                    this.setSelectNode(this.orgData,this.selectedId)
                }else{
                    this.orgData = JSON.parse(this.tempObj)
                    this.setSelectNode(this.orgData,this.selectedId)
                }
            },
            filterNode(data){
                let filtered = true;
                data.map(item => {
                  if(item.children){
                    for(var i = 0 ; i < item.children.length ; i++){
                        if(item.children[i].children && item.children[i].children.length > 0){
                            if(!this.filterNode(item.children[i]) && item.children[i].name.indexOf(this.searchInput) == -1){
                                item.children.splice(i,1)
                                i --;
                            }
                        }else {
                            if(item.children[i].name.indexOf(this.searchInput) == -1) {
                                item.children.splice(i,1)
                                i --;
                            }
                        }
                    }
                    if(item.children.length == 0){
                        filtered = false;
                    }

                    for(var j = 0 ; j < item.children.length ; j++){
                        if(j == item.children.length - 1){
                            item.children[j].isLastNode = true
                        }else{
                            item.children[j].isLastNode = false
                        }
                    }
                  }
                  return filtered;
                })
                
            },
            showOrgTree(){
                this.isSelectOrg = true;
            },
            initOrgTree(data,selectNodeId) {
                if(data){
                    this.orgData = data
                    this.tempObj = JSON.stringify(this.orgData)
                    this.setTree(selectNodeId)
                    this.filterOrg = lodash.debounce(this.getFilterOrg, 400)
                }else{
                  
                      this.$http.get(config.api.get_scenes_fence + this.orgLink).then(resp => {
                        if(resp.code == 0) {
                          const result = resp.result.map(item => {
                            item.isExpand = true
                            item.name = item.title
                            const children = item.children.map(every => {
                                return {
                                    data: every.data,
                                    title: every.title,
                                    name: every.title,
                                    type: every.type,
                                    selected: every.selected,
                                    expand: every.expand,
                                    isExpand: false,
                                    isLastNode: true
                                };
                            })
                            return {
                                ...item,
                                children: children
                            };
                          })
                          this.orgData = result
                          this.tempObj = JSON.stringify(this.orgData)
                          this.setTree(selectNodeId)
                          this.filterOrg = lodash.debounce(this.getFilterOrg, 400)
                        }
                      })
                }
                var that = this;

                function ready(fn) {
                    if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading"){
                        fn();
                    } else {
                        document.addEventListener('DOMContentLoaded', fn);
                    }
                }

                ready(function(){
                    document.body.addEventListener('mousedown', function(event){
                        let element = event.target
                        let isOrgInput = false;
                        let isTreeDiv = false;
                        while(element){
                            if(that.option.id){
                                if(element.id == that.option.id){
                                    isOrgInput = true
                                }
                            }else if(element.id == 'orgInput2'){
                                isOrgInput = true
                            }

                            if(element.id == 'treeDiv'){
                                isTreeDiv = true
                            }
                            element = element.parentElement || element.parentNode || null
                        }
                        if(isOrgInput){
                            that.isSelectOrg = true;
                        }else{
                            if(!isTreeDiv){
                                that.isSelectOrg = false;
                            }
                            if(event.target.id == 'cancelUpdate'){
                                that.$emit('closeUpdateOrgModel');
                            }
                        }
                    });
                });
            },
            setTree(selectNodeId){
                this.selectedId = selectNodeId ? selectNodeId :this.orgData.id
                let selectedNode = this.getNodeById(this.orgData,this.selectedId)
                // this.onSelectNode(selectedNode)
            },

            getNodeById(data,nodeId){
                if(data.id == nodeId){
                    return data
                }
                if(data.children != null){
                    for(var i = 0 ; i < data.children.length ; i ++){
                         let node = this.getNodeById(data.children[i],nodeId);
                         if(node){
                             return node;
                         }
                    }
                }
                return null;
            },

            getSelectNodeId(node){
                let _this = this
                if(node.isSelected == true){
                    return node.id;
                }
                if(node.children != null){
                    for(var i = 0 ; i < node.children.length ; i ++){
                        let nodeId =  _this.getSelectNodeId(node.children[i]);
                        if(nodeId){
                            return nodeId;
                        }
                    }
                }
                return null;
            },

            setSelectNode(node,selectNodeId){
                if(node.id === selectNodeId){
                    node.isSelected = true;
                }else{
                    node.isSelected = false;
                }

                //TO DO 此处值改变后页面未重新渲染，暂未找到解决办法
                var temp = node.name;
                node.name = '';
                node.name = temp;

                var that = this
                if(node.children != null && node.children.length > 0){
                    node.children.map(function(item){
                        that.setSelectNode(item,selectNodeId);
                    })
                }
            },
            directChange(){
                this.$emit("directChange", this.option.directFlag)
            },
            onSelectNode(node){
                this.setSelectNode(this.orgData,node.id);
                this.selectedId = node.id
                this.isSelectOrg = false
                this.option.value = node.link
                this.option.name = node.name
                this.option.orgId = node.id
                this.systemName = node.name
                this.$emit("sceneSelect",node)
            }
        }
    }
</script>


<style lang="less" scoped>
@import '../../theme/page.less';
.absoluteTree{
    position: absolute;
    z-index: 100;
    .liner-gradient-body;
}
.ztree {
    max-height: 75vh;
    overflow-y: auto;
}
</style>
